import { render, staticRenderFns } from "./CartPoint.vue?vue&type=template&id=83e23fde&scoped=true&"
import script from "./CartPoint.vue?vue&type=script&lang=js&"
export * from "./CartPoint.vue?vue&type=script&lang=js&"
import style0 from "./CartPoint.vue?vue&type=style&index=0&id=83e23fde&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83e23fde",
  null
  
)

export default component.exports